// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DunningDetailsController = function ($scope, $http, $routeParams, $location, Dunning, DunningDownload) {
    $scope.dunning = Dunning.get({ dunningId: $routeParams.dunningId });

    $scope.save = function () {
        $scope.dunning.$update({ dunningId: $routeParams.dunningId }, function () { $location.path("/documents/dunnings-drafts"); });
    };

    $scope.sendDunning = function (draftId) {
        if($scope.isSendRequestProcessing) {
            return;
        }

        $scope.isSendRequestProcessing = true;
        
        $scope.dunning.$update({ dunningId: $routeParams.dunningId }, function () {
            $http({
                method: "POST",
                url: "/api/v1/Dunnings/" + draftId + "/send",
                params: null,
                data: {},
                headers: {},
                cache: false
            }).then(function () {
                $location.path("/documents/dunnings-final");
            }).finally(function () {
                $scope.isSendRequestProcessing = false;
            });
        });
    };

    $scope.download = function (id) {
        var downloadInfo = new DunningDownload();
        downloadInfo.$save({ dunningId: id }, function () {
            window.location = downloadInfo.Url;
        });
    };

    $scope.backHistory = function () {
        window.history.back();
    }
};
DunningDetailsController.$inject = ['$scope', '$http', '$routeParams', '$location', 'Dunning', 'DunningDownload'];
